import { tracked } from '@glimmer/tracking';

// Class used to more easily use the alert/key dates entries from the OD Alerts response
export default class OdAlertsResponseEntry {
  @tracked isKeyDate = false;

  alerts = [];
  currentPosition = null;
  currentPrice = null;
  currentPriceMessage = null;
  events = [];
  fromDate = '';
  marketOtb = null;
  marketOtbPickup = null;
  notes = [];
  otb = null;
  otbPickup = null;

  constructor(
    alerts,
    events,
    notes,
    currentPosition,
    currentPrice,
    currentPriceMessage,
    fromDate,
    isKeyDate,
    marketOtb,
    marketOtbPickup,
    otb,
    otbPickup,
  ) {
    this.alerts = alerts;
    this.events = events;
    this.notes = notes;
    this.currentPosition = currentPosition;
    this.currentPrice = currentPrice;
    this.currentPriceMessage = currentPriceMessage;
    this.fromDate = fromDate;
    this.isKeyDate = isKeyDate;
    this.marketOtb = marketOtb;
    this.marketOtbPickup = marketOtbPickup;
    this.otb = otb;
    this.otbPickup = otbPickup;
  }

  static fromApiResponse(apiResponseEntry) {
    return new OdAlertsResponseEntry(
      apiResponseEntry.alerts,
      apiResponseEntry.events,
      apiResponseEntry.notes,
      apiResponseEntry.current_position,
      apiResponseEntry.current_price,
      apiResponseEntry.current_price_message,
      apiResponseEntry.from_date,
      apiResponseEntry.is_key_date,
      apiResponseEntry.market_otb,
      apiResponseEntry.market_otb_pickup,
      apiResponseEntry.otb,
      apiResponseEntry.otb_pickup,
    );
  }
}
